import { useEffect, useRef } from 'react'

interface TimerProps {
  duration: number
  onTimerExpired: () => void
}

const Timer = ({ onTimerExpired, duration }: TimerProps): null => {
  const timer = useRef(null)

  const clearTimer = () => {
    timer.current && clearTimeout(timer.current)
  }

  const startTimer = (duration: number) => {
    clearTimer()
    timer.current = setTimeout(onTimerExpired, duration * 1000)
  }

  useEffect(() => {
    startTimer(duration)

    return () => {
      clearTimer()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    startTimer(duration)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration])

  return null
}

export default Timer
